import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bulma/css/bulma.min.css';
import { HashRouter as Router } from "react-router-dom";


const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <Router><App/></Router>,
    rootElement
  );
} else {
  ReactDOM.render(
    <Router><App/></Router>,
    rootElement
  );
}

serviceWorker.unregister();